export const BASE_CLASSES_MD = "h-11 w-11 rounded-lg"
export const BASE_CLASSES_SM = "h-8 w-8 rounded-md"
